import { BuilderComponent } from "@builder.io/react"
import * as React from "react"
import { Helmet } from "react-helmet"
import Link from "../components/Link/Link"
import Layout from "../layouts/RootLayout"

function BlogArticleDetail({ pageContext }) {
  const { content } = pageContext
  const articleUrl = `https://www.jeffpiscine.fr/blog/${content.data.handle}`

  // Structured data for SEO (JSON-LD)
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: content.data.title,
    description: content.data.description,
    image: content.data.image,
    author: {
      "@type": "Organization",
      name: "Jeffpiscine",
    },
    publisher: {
      "@type": "Organization",
      name: "Jeffpiscine",
      logo: {
        "@type": "ImageObject",
        url: "https://www.jeffpiscine.fr/img/jeffpiscine-logo-plus-text.png",
      },
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": articleUrl,
    },
  }

  return (
    <Layout>
      <Helmet>
        <title>Jeffpiscine.fr - {content.data.title}</title>
        <meta name="description" content={content.data.description} />
        <link rel="canonical" href={articleUrl} />

        {/* Open Graph */}
        <meta property="og:title" content={content.data.title} />
        <meta property="og:description" content={content.data.description} />
        <meta property="og:image" content={content.data.image} />
        <meta property="og:url" content={articleUrl} />
        <meta property="og:type" content="article" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={content.data.title} />
        <meta name="twitter:description" content={content.data.description} />
        <meta name="twitter:image" content={content.data.image} />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      <BuilderComponent renderLink={Link} name="article" content={content} />
    </Layout>
  )
}

export default BlogArticleDetail
